import awsmobile from './aws-exports';

export const awsexport = awsmobile;
export * from './API';
export * as mutations from './graphql/mutations';
export * as queries from './graphql/queries';
export * as subscriptions from './graphql/subscriptions';
